<ul class="navigation__list-dropdown links-menu">
  @for (child of visibleItems(); track $index) {
    <li
      class="navigation__list-item navigation__list-item--second-level col-12"
      [ngClass]="{
        'col-md-3': visibleItems().length >= 4,
        'col-md-4': visibleItems().length < 4,
        show: dropdownOpen() === $index,
      }"
    >
      @if (child.childLinks) {
        <button class="navigation__list-item-link navigation__list-item-button" type="button" (click)="toggleDropdown($index)">
          <ng-container *ngTemplateOutlet="StoreNavLinkTitle" />
        </button>

        <ul class="navigation__list list-unstyled" [ngClass]="{ hide: dropdownOpen() !== $index }">
          @for (item of child.childLinks; track $index) {
            @if (!item.hidden) {
              <li class="navigation__list-item--third-level">
                <a [routerLink]="item.linkedPage" (click)="clickItem()">
                  <span [innerHTML]="item.title"></span>
                </a>
              </li>
            }
          }
          @if (child.linkedPage) {
            <li class="navigation__list-item--see-all">
              <a [routerLink]="child.linkedPage" (click)="clickItem()">
                <span class="circle-arrow-before" i18n="@@SEE_ALL">See all</span>
              </a>
            </li>
          }
        </ul>
      } @else {
        <a class="navigation__list-item-link" [routerLink]="[child.linkedPage]">
          <ng-container *ngTemplateOutlet="StoreNavLinkTitle" />
        </a>
      }
      <ng-template #StoreNavLinkTitle>
        <span class="navigation__list-item-title" [innerHtml]="child.title"></span>
        @if (child.childLinks) {
          <span class="d-inline-block d-lg-none">
            <i class="fal fa-plus"></i>
            <i class="fal fa-minus"></i>
          </span>
        }
      </ng-template>
    </li>
  }
</ul>
